import { useAPI } from '../../../clients/quipli-service/quipli-service-client';
import { useContext, useEffect, useState } from 'react';
import { Typography } from '../../../components/typography/typography';
import { Field } from '../../../components/field/field';
import { Button } from '../../../components/form/button';
import { TenantContext } from '../../../context/tenant-context';
import { usePaymentConfigApiV1 } from '../../../clients/quipli-service/payment-config/payment-config-api-v1';

export const StripeAccountSetupExisting = () => {
  const [authCode, setAuthCode] = useState<string>('');
  const [stripeAuthUrl, setStripeAuthUrl] = useState<string>('');
  const { contextPath } = useContext(TenantContext);

  const { getConfiguration } = useAPI();
  const { authorizeStripeAccount } = usePaymentConfigApiV1();
  useEffect(() => {
    getConfiguration('CONF_STRIPE_AUTH_URL').then((stripeAuthConf) => {
      if (stripeAuthConf) {
        setStripeAuthUrl(stripeAuthConf.value);
      }
    });
  }, []);

  async function authorizationStep() {
    await authorizeStripeAccount(authCode);
    window.location.href = `${contextPath}manager/quipli-pay`;
  }

  return stripeAuthUrl.length < 0 ? (
    <></>
  ) : (
    <div>
      <div className={'section-head'}>
        <Typography type={'display-md'}>Existing Account Setup</Typography>
      </div>
      <div>
        <Button onClick={() => window.open(stripeAuthUrl, '_blank')}>Authorize Account</Button>
      </div>
      <p>
        Please authorize your Stripe account using the button above to connect with Quipli. Once you completed, you will
        see a screen similiar the to below screenshot. Please copy and paste your auth_code in the text box below to
        connect your Stripe standard account with Quipli.
      </p>
      <img height="500px" src="/images/stripe_instructions.png"></img>
      <div>
        <Field
          type={'text'}
          label={'Authorization Code'}
          value={authCode}
          onChange={(value) => {
            setAuthCode(value);
          }}
        />
      </div>
      <Button className={'button-primary'} onClick={() => authorizationStep()} disabled={authCode.length < 12}>
        Connect Account
      </Button>
    </div>
  );
};
